export default [
  {path: '/sl/tarefas', component: () => import('./components/ListaTarefas'), name: 'sl.tarefas.lista'},
  {
    path: '/tasks', component: () => import('./components/Page'), name: 'tasks.page', children: [
      { path: '/tasks/:id', name: 'task.show', component: () => import('./components/OpenTask')}
    ]
  }
]
